<template>
  <div class="mt-6">
    <v-layout row wrap>
      <v-flex>
        <section>
          <v-row>
            <v-col>
              <div class="d-flex justify-center">
                <div class="blue_one d-flex align-center">
                  <v-img
                    :src="require('@/assets/icon/user.png')"
                    
                    width="20" height="20"
                    class="mt-0">
                  </v-img>
                  <div class="ml-3">
                    Informasi User
                  </div>
                </div>
                <div class="mx-5 black_three">
                  -----
                </div>
                <div class="d-flex align-center" :class="$route.path.split('/')[2] === 'jenis-usaha' || $route.path.split('/')[2] === 'informasi-usaha' ? 'blue_one' : 'black_three'">
                  <v-img
                    :src="$route.path.split('/')[2] === 'jenis-usaha' || $route.path.split('/')[2] === 'informasi-usaha' ? require('@/assets/icon/jenis-usaha.png') : require('@/assets/icon/user-grey.png')"
                    width="20" height="20"
                    class="mt-1">
                  </v-img>
                  <div class="ml-3">
                    Jenis Usaha
                  </div>
                </div>
                <div class="mx-5 black_three">
                  -----
                </div>
                <div class="d-flex align-center" :class="$route.path.split('/')[2] === 'informasi-usaha' ? 'blue_one' : 'black_three'">
                  <v-img
                    :src="$route.path.split('/')[2] === 'informasi-usaha' ? require('@/assets/icon/informasi-usaha.png') : require('@/assets/icon/informasi-usaha-grey.png')"
                    
                    width="20" height="20"
                    class="mt-0">
                  </v-img>
                  <div class="ml-3">
                    Informasi Usaha
                  </div>
                </div>
              </div>


              <div>
                <router-view />
              </div>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data() {
      return {
        process: {
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      company () {
        return this.$store.state.company
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+35}, ${g+37}, ${b}, 0.97)`
      }
    },
    mounted () {
      
    },
    methods: {

    }
  }
</script>